<template>
  <div class="newspaper">
    <img src="../../assets/arrow.png" class="arrow" @click="home()" v-if="!displaySummary" />
    <div class="newspaper-container">
      <div v-if="displaySummary">
        <h1>NEWS</h1>
        <div class="flex-container">
          <div style="width: 20em;">
            <br />
            <img src="../../assets/NewYear/newsPicture.png" alt />
          </div>
          <div style="width: 20em; font-size:14px">
            <p>
              <b>
                Panique au club nautique : n'ayant pas les moyens d'offrir du crabe à sa bien-aimée
                pour le réveillon, il emprunte un catamaran pour partir à la pêche et dérive au large
                !
              </b>
            </p>
            <p>
              <em>
                Découvrez l'histoire rocambolesque de Pierre-Georges, mêlant amour, gastronomie et
                bêtise humaine. Il a mis sa vie en danger pour un crustacé : les secours ont dû
                intervenir.
              </em>
            </p>
          </div>
        </div>
        <br />
        <h1></h1>
        <h3>Nos rubriques habituelles à ne pas manquer ce mercredi :</h3>
        <div class="games">
          <p v-on:click="toggleCastle()">Le jeu trop classe</p>
          <p v-on:click="toggleReceipe()">La recette de Maïté</p>
          <p v-on:click="toggleCrossword()">Mots croisés</p>
          <p v-on:click="toggleQuiz()">Quiz</p>
        </div>
        <br />
        <h1></h1>
        <p>
          <b>Grand dossier spécial Saint Sylvestre :</b> quels sont les meilleurs jeux de société
          pour vous amuser vous et vos amis en attendant les douzes coups de minuits ?
        </p>
        <p>
          <em>
            A la rédaction, nous avons testé toutes les dernières nouveautés accompagnés par Carlos
            ! Découvrez dans les pages suivantes nos titres préféré.
          </em>
        </p>
      </div>
      <Castle
        v-if="displayCastle"
        :hintList="hintList"
        @updateHints="hintList = $event"
        @incrementCounter="increment()"
      />
      <Receipe
        v-if="displayReceipe"
        :hintList="hintList"
        @updateHints="hintList = $event"
        @incrementCounter="increment()"
      />
      <Crossword
        v-if="displayCrossword"
        :hintList="hintList"
        @updateHints="hintList = $event"
        @incrementCounter="increment()"
        :crosswordLetters="letters"
        @save="$emit('save',$event)"
      />
      <Quiz
        v-if="displayQuiz"
        :hintList="hintList"
        @updateHints="hintList = $event"
        @incrementCounter="increment()"
      />
    </div>
  </div>
</template>

<script>
import Castle from "./Newspaper/Castle.vue";
import Receipe from "./Newspaper/Receipe.vue";
import Crossword from "./Newspaper/Crossword.vue";
import Quiz from "./Newspaper/Quiz.vue";

export default {
  name: "Newspaper",
  props: {
    hintList: Array,
    crosswordLetters: Object
  },
  components: {
    Castle,
    Receipe,
    Crossword,
    Quiz
  },
  data() {
    return {
      displaySummary: true,
      displayCastle: false,
      displayReceipe: false,
      displayQuiz: false,
      displayCrossword: false,
      hints: this.hintList,
      letters: this.crosswordLetters
    };
  },
  methods: {
    toggleCastle() {
      this.displayCastle = this.displayCastle ? false : true;
      this.displaySummary = false;
      this.displayReceipe = false;
      this.displayQuiz = false;
      this.displayCrossword = false;
    },
    toggleReceipe() {
      this.displayReceipe = this.displayReceipe ? false : true;
      this.displayCastle = false;
      this.displaySummary = false;
      this.displayQuiz = false;
      this.displayCrossword = false;
    },
    toggleCrossword() {
      this.displayCrossword = this.displayCrossword ? false : true;
      this.displayReceipe = false;
      this.displayCastle = false;
      this.displaySummary = false;
      this.displayQuiz = false;
    },
    toggleQuiz() {
      this.displayQuiz = this.displayQuiz ? false : true;
      this.displayReceipe = false;
      this.displayCastle = false;
      this.displaySummary = false;
      this.displayCrossword = false;
    },
    home() {
      this.displaySummary = true;
      this.displayCastle = false;
      this.displayReceipe = false;
      this.displayQuiz = false;
      this.displayCrossword = false;
    },
    increment() {
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap");
p {
  font-size: 14px;
}
.newspaper {
  top: 0;
  position: relative;
  margin: 0;
  height: 88%;
  font-family: "Playfair Display", serif;
  color: rgb(35, 35, 35);
}
.newspaper p {
  font-family: "Playfair Display", serif;
}
.newspaper h3 {
  font-family: "Playfair Display", serif;
  font-weight: light;
}
.newspaper h1 {
  font-family: "Playfair Display", serif;
  font-weight: bold;
  color: rgb(35, 35, 35);
  font-size: 300%;
  margin-top: 0;
  border-bottom: double rgb(35, 35, 35);
  width: 100%;
}
.newspaper-container {
  width: 82%;
  height: 90%;
  margin: 6%;
  padding: 3%;
  background: rgb(225, 225, 225);
  overflow: scroll;
  font-family: "IBM Plex Mono", monospace;
  font-size: 15px;
}
.newspaper-container img {
  width: 90%;
  border: double rgb(35, 35, 35);
}
.arrow {
  position: absolute;
  height: 6% !important;
  bottom: 4%;
  left: 7%;
  height: 8%;
  cursor: pointer;
}
.games p {
  cursor: pointer;
}
.flex-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
}
</style>
